import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Presentation = styled.div`
  padding-top: 2px;
  width: 100%;
  margin-bottom: 70px;
`;

export const DivInformation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 300px;
  width: 100%;

  .profilePhoto {
    border-radius: 50%;
    width: 200px;
    padding-top: 20px;
    margin: 12px;
  }

  h1 {
    font-size: 1.5rem;
    color: teal;
  }

  hr {
    width: 100%;
    position: relative;
    top: 30px;
  }
`;

export const DivAboutMe = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  
  h1 {
    font-size: 1.5rem;
    color: teal;
  }

  p{
    font-size: 1.3rem;
    padding: 3rem;
    line-height: 2rem;
    text-align: justify;
    width: 100%;
    max-width: 1200px;
  }
`;
